export default "__VITE_ASSET__BW2APiRQ__"